import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { TimeOffPolicy } from '@models/time-off-v3/time-off-policy.model';

/**
 * Prevent access to pages that require a policy to be an accrual based policy
 */
@Injectable()
export class AccrualPolicyGuard {
    constructor(private readonly router: Router) {}

    async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
        const timeOffPolicy = await TimeOffPolicy.find(route.paramMap.get('policy'));

        if (timeOffPolicy.isUnlimited) {
            await this.router.navigate(['/dashboard']);
            return false;
        }

        return true;
    }
}
